// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

/* Prevent horizontal scrolling on all elements */
* {
  box-sizing: border-box;
}

/* Ensure containers don't exceed viewport width */
#root {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
}

/* Global Design System Variables */
:root {
  --primary-navy: #1F77B4;
  --primary-teal: #17BECF;
  --primary-orange: #FF7F0E;
  --primary-gray: #7F7F7F;
  --light-gray: #f8f9fa;
  --white: #ffffff;
  --dark-text: #2d3748;
  --muted-text: #718096;
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 16px;
  --border-radius-xl: 20px;
  --shadow-sm: 0 2px 8px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.12);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.15);
  --shadow-xl: 0 16px 64px rgba(0,0,0,0.2);
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
}

/* Professional Card System */
.professional-card {
  background: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(31, 119, 180, 0.08);
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.professional-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--primary-navy);
  opacity: 0.8;
}

.professional-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(31, 119, 180, 0.15);
}

/* Info Card System */
.info-card {
  background: var(--white);
  border-radius: var(--border-radius-md);
  border: 2px solid rgba(31, 119, 180, 0.1);
  padding: 20px;
  text-align: center;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  font-size: 16px;
  line-height: 1.4;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--primary-navy);
  transform: scaleX(0);
  transition: transform var(--transition-normal);
}

.info-card:hover::before {
  transform: scaleX(1);
}

.info-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
  border-color: var(--primary-navy);
}

/* Professional Select System */
.professional-select {
  width: 100%;
  padding: 18px 20px;
  padding-right: 50px;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 16px;
  color: var(--dark-text);
  background: var(--light-gray);
  cursor: pointer;
  transition: all var(--transition-normal);
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-shadow: var(--shadow-sm);
  font-weight: 500;
  font-family: inherit;
  min-height: 60px;
  line-height: 1.4;
}

.professional-select:focus {
  background: var(--white);
  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);
  transform: translateY(-2px);
}

.professional-select:hover:not(:focus) {
  background: var(--white);
  transform: translateY(-1px);
}

/* Custom Dropdown System */
.custom-dropdown {
  position: relative;
  width: 100%;
  z-index: 1;
}

.custom-dropdown.open {
  z-index: 100000;
}

.custom-dropdown-button {
  width: 100%;
  padding: 18px 20px;
  padding-right: 50px;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 18px;
  color: var(--dark-text);
  background: var(--light-gray);
  cursor: pointer;
  transition: all var(--transition-normal);
  outline: none;
  box-shadow: var(--shadow-sm);
  font-weight: 500;
  font-family: inherit;
  text-align: left;
  min-height: 60px;
  display: flex;
  align-items: center;
  line-height: 1.4;
}

.custom-dropdown-button:focus {
  background: var(--white);
  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);
  transform: translateY(-2px);
}

.custom-dropdown-button:hover:not(:focus) {
  background: var(--white);
  transform: translateY(-1px);
}

.custom-dropdown-button.open {
  background: var(--white);
  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);
  transform: translateY(-2px);
}

.custom-dropdown-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid var(--primary-gray);
  transition: all var(--transition-normal);
}

.custom-dropdown-button.open .custom-dropdown-arrow {
  transform: translateY(-50%) rotate(180deg);
  border-top-color: var(--primary-navy);
}

.custom-dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--white);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(31, 119, 180, 0.1);
  z-index: 99999;
  max-height: none;
  overflow-y: visible;
  margin-top: 4px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-5px) scale(0.99);
  transition: all var(--transition-normal);
  transform-origin: top;
}

.custom-dropdown-list.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

.custom-dropdown-item {
  padding: 16px 20px;
  cursor: pointer;
  transition: all var(--transition-fast);
  border-bottom: 1px solid rgba(31, 119, 180, 0.05);
  font-size: 18px;
  color: var(--dark-text);
  display: flex;
  align-items: center;
  gap: 12px;
  line-height: 1.4;
}

.custom-dropdown-item:last-child {
  border-bottom: none;
}

.custom-dropdown-item:hover {
  background: var(--light-gray);
  color: var(--primary-navy);
}

.custom-dropdown-item.selected {
  background: rgba(31, 119, 180, 0.1);
  color: var(--primary-navy);
  font-weight: 600;
}

.custom-dropdown-item-number {
  background: var(--primary-navy);
  color: var(--white);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.custom-dropdown-item.selected .custom-dropdown-item-number {
  background: var(--primary-teal);
}

/* No scrollbar needed since all options are visible */

/* Specific fix for AnalysisControls card to allow dropdown overflow */
.analysis-controls-card {
  overflow: visible !important;
}

.analysis-controls-card .professional-card {
  overflow: visible !important;
}

/* Ensure VisualizationSection card doesn't interfere with dropdowns */
.visualization-section-card {
  z-index: 1 !important;
}

.visualization-section-card .professional-card {
  z-index: 1 !important;
}

/* Ensure visualization section has consistent border styling */
.visualization-section-card.professional-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--primary-navy);
  opacity: 0.8;
  z-index: 1;
}

/* Ensure all dropdowns appear above everything */
.custom-dropdown-list,
.custom-dropdown-list.open {
  z-index: 999999 !important;
  position: absolute !important;
}

/* Ensure dropdown containers have proper z-index when open */
.custom-dropdown.open {
  z-index: 999999 !important;
}

/* Dropdown animation keyframes */
@keyframes dropdownSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-5px) scale(0.99);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Professional Button System */
.professional-button {
  padding: 14px 28px;
  border-radius: var(--border-radius-md);
  border: 2px solid var(--primary-navy);
  background: var(--white);
  color: var(--dark-text);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: inherit;
  font-size: 16px;
  line-height: 1.4;
}

@media (min-width: 768px) {
  .professional-button {
    font-size: 18px;
  }
}

.professional-button:hover {
  border-color: var(--primary-navy);
  background: var(--light-gray);
}

.professional-button.active {
  background: var(--primary-navy);
  color: var(--white);
}

.professional-button:active {
  transform: scale(0.98);
}

/* Container System */
.professional-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* Typography System */
.professional-heading {
  color: var(--primary-navy);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.professional-text {
  color: var(--muted-text);
  line-height: 1.6;
}

/* Consistent Typography Scale */
.typography-h1 {
  font-size: 2.5rem; /* 40px */
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.typography-h2 {
  font-size: 2rem; /* 32px */
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.typography-h3 {
  font-size: 1.5rem; /* 24px */
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.025em;
}

.typography-h4 {
  font-size: 1.25rem; /* 20px */
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.02em;
}

.typography-h5 {
  font-size: 1.125rem; /* 18px */
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.015em;
}

.typography-h6 {
  font-size: 1rem; /* 16px */
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.01em;
}

.typography-body-lg {
  font-size: 1.125rem; /* 18px */
  font-weight: 400;
  line-height: 1.6;
}

.typography-body {
  font-size: 1rem; /* 16px */
  font-weight: 400;
  line-height: 1.6;
}

@media (min-width: 768px) {
  .typography-body {
    font-size: 1.125rem; /* 18px */
  }
}

.typography-body-sm {
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: 1.5;
}

@media (min-width: 768px) {
  .typography-body-sm {
    font-size: 1.125rem; /* 18px */
  }
}

.typography-caption {
  font-size: 0.75rem; /* 12px */
  font-weight: 500;
  line-height: 1.4;
}

@media (min-width: 768px) {
  .typography-caption {
    font-size: 1.125rem; /* 18px */
  }
}

.typography-caption-xs {
  font-size: 0.625rem; /* 10px */
  font-weight: 500;
  line-height: 1.3;
}

/* Responsive Typography */
@media (max-width: 768px) {
  .typography-h1 {
    font-size: 2rem; /* 32px */
  }
  
  .typography-h2 {
    font-size: 1.75rem; /* 28px */
  }
  
  .typography-h3 {
    font-size: 1.375rem; /* 22px */
  }
  
  .typography-h4 {
    font-size: 1.125rem; /* 18px */
  }
  
  .typography-h5 {
    font-size: 1rem; /* 16px */
  }
  
  .typography-h6 {
    font-size: 0.875rem; /* 14px */
  }
  
  .typography-body-lg {
    font-size: 1rem; /* 16px */
  }
  
  .typography-body {
    font-size: 0.875rem; /* 14px */
  }
  
  .typography-body-sm {
    font-size: 0.75rem; /* 12px */
  }
}

/* Loading and Animation */
@keyframes professional-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.professional-loading {
  animation: professional-pulse 2s ease-in-out infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .professional-container {
    padding: 0 16px;
  }
  
  .professional-card {
    border-radius: var(--border-radius-md);
  }
  
  .info-card {
    padding: 12px;
  }
}

code {
  font-family: 'JetBrains Mono', 'Fira Code', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  background: var(--light-gray);
  padding: 2px 6px;
  border-radius: var(--border-radius-sm);
  font-size: 0.875em;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sDAAsD;;AAEtD,sEAAsE;AACtE;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,UAAU;AACZ;;AAEA,iDAAiD;AACjD;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,6DAA6D;AAC7D;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;EACrC,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA;EACE,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB,EAAE,SAAS;EAChC;AACF;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe,EAAE,SAAS;EAC5B;;EAEA;IACE,kBAAkB,EAAE,SAAS;EAC/B;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,eAAe,EAAE,SAAS;EAC5B;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,eAAe,EAAE,SAAS;EAC5B;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,kBAAkB,EAAE,SAAS;EAC/B;AACF;;AAEA,0BAA0B;AAC1B;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;aACW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  width: 100%;\n  max-width: 100%;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  min-height: 100vh;\n}\n\n/* Prevent horizontal scrolling on all elements */\n* {\n  box-sizing: border-box;\n}\n\n/* Ensure containers don't exceed viewport width */\n#root {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  min-height: 100vh;\n}\n\n/* Global Design System Variables */\n:root {\n  --primary-navy: #1F77B4;\n  --primary-teal: #17BECF;\n  --primary-orange: #FF7F0E;\n  --primary-gray: #7F7F7F;\n  --light-gray: #f8f9fa;\n  --white: #ffffff;\n  --dark-text: #2d3748;\n  --muted-text: #718096;\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 16px;\n  --border-radius-xl: 20px;\n  --shadow-sm: 0 2px 8px rgba(0,0,0,0.08);\n  --shadow-md: 0 4px 16px rgba(0,0,0,0.12);\n  --shadow-lg: 0 8px 32px rgba(0,0,0,0.15);\n  --shadow-xl: 0 16px 64px rgba(0,0,0,0.2);\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n}\n\n/* Professional Card System */\n.professional-card {\n  background: var(--white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid rgba(31, 119, 180, 0.08);\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.professional-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--primary-navy);\n  opacity: 0.8;\n}\n\n.professional-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n  border-color: rgba(31, 119, 180, 0.15);\n}\n\n/* Info Card System */\n.info-card {\n  background: var(--white);\n  border-radius: var(--border-radius-md);\n  border: 2px solid rgba(31, 119, 180, 0.1);\n  padding: 20px;\n  text-align: center;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.info-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--primary-navy);\n  transform: scaleX(0);\n  transition: transform var(--transition-normal);\n}\n\n.info-card:hover::before {\n  transform: scaleX(1);\n}\n\n.info-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n  border-color: var(--primary-navy);\n}\n\n/* Professional Select System */\n.professional-select {\n  width: 100%;\n  padding: 18px 20px;\n  padding-right: 50px;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 16px;\n  color: var(--dark-text);\n  background: var(--light-gray);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  box-shadow: var(--shadow-sm);\n  font-weight: 500;\n  font-family: inherit;\n  min-height: 60px;\n  line-height: 1.4;\n}\n\n.professional-select:focus {\n  background: var(--white);\n  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);\n  transform: translateY(-2px);\n}\n\n.professional-select:hover:not(:focus) {\n  background: var(--white);\n  transform: translateY(-1px);\n}\n\n/* Custom Dropdown System */\n.custom-dropdown {\n  position: relative;\n  width: 100%;\n  z-index: 1;\n}\n\n.custom-dropdown.open {\n  z-index: 100000;\n}\n\n.custom-dropdown-button {\n  width: 100%;\n  padding: 18px 20px;\n  padding-right: 50px;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 18px;\n  color: var(--dark-text);\n  background: var(--light-gray);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  outline: none;\n  box-shadow: var(--shadow-sm);\n  font-weight: 500;\n  font-family: inherit;\n  text-align: left;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  line-height: 1.4;\n}\n\n.custom-dropdown-button:focus {\n  background: var(--white);\n  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);\n  transform: translateY(-2px);\n}\n\n.custom-dropdown-button:hover:not(:focus) {\n  background: var(--white);\n  transform: translateY(-1px);\n}\n\n.custom-dropdown-button.open {\n  background: var(--white);\n  box-shadow: 0 4px 20px rgba(31, 119, 180, 0.25);\n  transform: translateY(-2px);\n}\n\n.custom-dropdown-arrow {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 8px solid var(--primary-gray);\n  transition: all var(--transition-normal);\n}\n\n.custom-dropdown-button.open .custom-dropdown-arrow {\n  transform: translateY(-50%) rotate(180deg);\n  border-top-color: var(--primary-navy);\n}\n\n.custom-dropdown-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--white);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid rgba(31, 119, 180, 0.1);\n  z-index: 99999;\n  max-height: none;\n  overflow-y: visible;\n  margin-top: 4px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-5px) scale(0.99);\n  transition: all var(--transition-normal);\n  transform-origin: top;\n}\n\n.custom-dropdown-list.open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n}\n\n.custom-dropdown-item {\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border-bottom: 1px solid rgba(31, 119, 180, 0.05);\n  font-size: 18px;\n  color: var(--dark-text);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  line-height: 1.4;\n}\n\n.custom-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.custom-dropdown-item:hover {\n  background: var(--light-gray);\n  color: var(--primary-navy);\n}\n\n.custom-dropdown-item.selected {\n  background: rgba(31, 119, 180, 0.1);\n  color: var(--primary-navy);\n  font-weight: 600;\n}\n\n.custom-dropdown-item-number {\n  background: var(--primary-navy);\n  color: var(--white);\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.custom-dropdown-item.selected .custom-dropdown-item-number {\n  background: var(--primary-teal);\n}\n\n/* No scrollbar needed since all options are visible */\n\n/* Specific fix for AnalysisControls card to allow dropdown overflow */\n.analysis-controls-card {\n  overflow: visible !important;\n}\n\n.analysis-controls-card .professional-card {\n  overflow: visible !important;\n}\n\n/* Ensure VisualizationSection card doesn't interfere with dropdowns */\n.visualization-section-card {\n  z-index: 1 !important;\n}\n\n.visualization-section-card .professional-card {\n  z-index: 1 !important;\n}\n\n/* Ensure visualization section has consistent border styling */\n.visualization-section-card.professional-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--primary-navy);\n  opacity: 0.8;\n  z-index: 1;\n}\n\n/* Ensure all dropdowns appear above everything */\n.custom-dropdown-list,\n.custom-dropdown-list.open {\n  z-index: 999999 !important;\n  position: absolute !important;\n}\n\n/* Ensure dropdown containers have proper z-index when open */\n.custom-dropdown.open {\n  z-index: 999999 !important;\n}\n\n/* Dropdown animation keyframes */\n@keyframes dropdownSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-5px) scale(0.99);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Professional Button System */\n.professional-button {\n  padding: 14px 28px;\n  border-radius: var(--border-radius-md);\n  border: 2px solid var(--primary-navy);\n  background: var(--white);\n  color: var(--dark-text);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n@media (min-width: 768px) {\n  .professional-button {\n    font-size: 18px;\n  }\n}\n\n.professional-button:hover {\n  border-color: var(--primary-navy);\n  background: var(--light-gray);\n}\n\n.professional-button.active {\n  background: var(--primary-navy);\n  color: var(--white);\n}\n\n.professional-button:active {\n  transform: scale(0.98);\n}\n\n/* Container System */\n.professional-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  width: 100%;\n}\n\n/* Typography System */\n.professional-heading {\n  color: var(--primary-navy);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.2;\n}\n\n.professional-text {\n  color: var(--muted-text);\n  line-height: 1.6;\n}\n\n/* Consistent Typography Scale */\n.typography-h1 {\n  font-size: 2.5rem; /* 40px */\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.typography-h2 {\n  font-size: 2rem; /* 32px */\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n}\n\n.typography-h3 {\n  font-size: 1.5rem; /* 24px */\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: -0.025em;\n}\n\n.typography-h4 {\n  font-size: 1.25rem; /* 20px */\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: -0.02em;\n}\n\n.typography-h5 {\n  font-size: 1.125rem; /* 18px */\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: -0.015em;\n}\n\n.typography-h6 {\n  font-size: 1rem; /* 16px */\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n}\n\n.typography-body-lg {\n  font-size: 1.125rem; /* 18px */\n  font-weight: 400;\n  line-height: 1.6;\n}\n\n.typography-body {\n  font-size: 1rem; /* 16px */\n  font-weight: 400;\n  line-height: 1.6;\n}\n\n@media (min-width: 768px) {\n  .typography-body {\n    font-size: 1.125rem; /* 18px */\n  }\n}\n\n.typography-body-sm {\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n@media (min-width: 768px) {\n  .typography-body-sm {\n    font-size: 1.125rem; /* 18px */\n  }\n}\n\n.typography-caption {\n  font-size: 0.75rem; /* 12px */\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n@media (min-width: 768px) {\n  .typography-caption {\n    font-size: 1.125rem; /* 18px */\n  }\n}\n\n.typography-caption-xs {\n  font-size: 0.625rem; /* 10px */\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n/* Responsive Typography */\n@media (max-width: 768px) {\n  .typography-h1 {\n    font-size: 2rem; /* 32px */\n  }\n  \n  .typography-h2 {\n    font-size: 1.75rem; /* 28px */\n  }\n  \n  .typography-h3 {\n    font-size: 1.375rem; /* 22px */\n  }\n  \n  .typography-h4 {\n    font-size: 1.125rem; /* 18px */\n  }\n  \n  .typography-h5 {\n    font-size: 1rem; /* 16px */\n  }\n  \n  .typography-h6 {\n    font-size: 0.875rem; /* 14px */\n  }\n  \n  .typography-body-lg {\n    font-size: 1rem; /* 16px */\n  }\n  \n  .typography-body {\n    font-size: 0.875rem; /* 14px */\n  }\n  \n  .typography-body-sm {\n    font-size: 0.75rem; /* 12px */\n  }\n}\n\n/* Loading and Animation */\n@keyframes professional-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.professional-loading {\n  animation: professional-pulse 2s ease-in-out infinite;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .professional-container {\n    padding: 0 16px;\n  }\n  \n  .professional-card {\n    border-radius: var(--border-radius-md);\n  }\n  \n  .info-card {\n    padding: 12px;\n  }\n}\n\ncode {\n  font-family: 'JetBrains Mono', 'Fira Code', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  background: var(--light-gray);\n  padding: 2px 6px;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
